import Immutable from 'immutable'

const initialUser = Immutable.fromJS({
  settings: {},
})

const actionHandlers = {
}

export default (user = initialUser, action) => {
  const actionHandler = actionHandlers[action.type]

  return (actionHandler)
    ? actionHandler(user, action)
    : user
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/user.js
 **/